import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { PictureAsPdf, Slideshow } from "@mui/icons-material";
import { management } from "./management.config";
import CustomCheckbox from "../../../../../../CustomForm/CustomCheckbox";
import CustomInput from "../../../../../../CustomForm/CustomInput";

const ManagementActionReport = () => {
  const [showData, setShowData] = useState(false);

  const handleButtonClick = () => {
    setShowData(!showData);
  };

  const reportData = [
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
    {
      dateTime: "25/01/2024 11:00",
      reportFrom: "01-12-2023",
      reportTo: "31-12-2023",
    },
  ];

  return (
    <Box>
      {/* Toggle Button */}
      <Button
        fullWidth
        variant="contained"
        color="primary"
        onClick={handleButtonClick}
        sx={{
          justifyContent: "flex-start",
          textAlign: "left",
          py: 1.5,
        }}
      >
        Audit Stats Report
      </Button>

      {/* Collapsible Content */}
      {showData && (
        <Card sx={{ mt: 3 }}>
          <CardContent>
            {/* Period / Zone / Service User / Carer */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label="Period*"
                  name="dateTime"
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <TextField
                  select
                  fullWidth
                  label="Select Zone"
                  defaultValue=""
                  size="small"
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="">Select</MenuItem>
                </TextField>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <CustomInput
                  label="Service User name"
                  name="user_service"
                  placeholder="Service User name"
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <CustomInput
                  label="Carer Name"
                  name="carer_name"
                  placeholder="Carer Name"
                />
              </Grid>
            </Grid>

            {/* Management Checkboxes */}
            <Grid container spacing={2} sx={{ py: 2, ml: 0.5 }}>
              {management.map((item, index) => (
                <Grid
                  key={index}
                  size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <CustomCheckbox />
                    <Box component="span" sx={{ ml: 1.5, mt: 0.5 }}>
                      {item}
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

            {/* Action Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                py: 1,
                my: 3,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ px: 4 }}
              >
                View Report Details
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ px: 4 }}
              >
                Generate report
              </Button>
            </Box>

            {/* Report Table */}
            <TableContainer component={Paper} variant="outlined">
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f8f9fa" }}>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Generated Date Time
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Report From
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Report To
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>
                      Download
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportData.map((data, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{data.dateTime}</TableCell>
                      <TableCell>{data.reportFrom}</TableCell>
                      <TableCell>{data.reportTo}</TableCell>
                      <TableCell>
                        <Tooltip title="Download PowerPoint" arrow>
                          <IconButton color="primary" size="large">
                            <Slideshow fontSize="large" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Download PDF" arrow>
                          <IconButton color="primary" size="large">
                            <PictureAsPdf fontSize="large" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ManagementActionReport;